import * as React from 'react'
import DataFeed from '../../model/DataFeed'
import { Col, FormLabel, Form, Card } from 'react-bootstrap'
import Row from 'react-bootstrap/Row'

interface Props {
  dataFeed: DataFeed
  type: string
  hasUnsavedChanges: boolean
  dataFeedChanged: (dataFeed: DataFeed) => void
}

export class DataFeedComponent extends React.Component<Props> {
  render() {
    var enabledControlValidationState = {}
    if (this.props.dataFeed.enabled !== null && this.props.hasUnsavedChanges) {
      enabledControlValidationState = {
        validationState: this.getValidationState('ReasonNotEnabled')
      }
    }

    return (
      <Card>
        <Card.Header style={{ backgroundColor: '#455560', color: 'white' }}>
          {this.props.type}
        </Card.Header>
        <Card.Body>
          <Form.Group {...enabledControlValidationState} className="has-feedback" as={Row}>
            <Col sm={2}>
              <Form.Check
                checked={this.props.dataFeed.enabled}
                onChange={() => this.handleEnabledChanged()}
                label="Enabled"
              />
            </Col>
            {!this.props.dataFeed.enabled && (
              <Col sm={10}>
                {/*todo why two wrap*/}
                <Form.Control
                  required={this.props.hasUnsavedChanges}
                  value={
                    this.props.dataFeed.reasonNotEnabled === null
                      ? ''
                      : this.props.dataFeed.reasonNotEnabled
                  }
                  placeholder="Why is this disabled for this site?"
                  // tslint:disable-next-line:no-any
                  onChange={(e: React.FormEvent<HTMLInputElement>) => this.handleReasonChanged(e.currentTarget.value || "")}
                />
                <Form.Control.Feedback type="invalid">
                  You must detail the reason this data feed is not enabled
                </Form.Control.Feedback>
              </Col>
            )}
          </Form.Group>
          <Form.Group as={Row}>
            <Col sm={2}>
              <FormLabel>Edited by</FormLabel>
            </Col>
            <Col sm={10}>
              <FormLabel>{this.props.dataFeed.editedByNT4Name}</FormLabel>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Col sm={2}>
              <FormLabel>Date edited</FormLabel>
            </Col>
            <Col sm={10}>
              <FormLabel>
                {this.props.dataFeed.dateEdited && this.props.dataFeed.dateEdited.toLocaleString()}
              </FormLabel>
            </Col>
          </Form.Group>
        </Card.Body>
      </Card>
    )
  }

  private getValidationState(property: string): 'success' | 'warning' | 'error' {
    if (
      this.props.hasUnsavedChanges &&
      this.props.dataFeed.validation &&
      this.props.dataFeed.validation.find(error => error.field === property)
    ) {
      return 'error'
    }
    return 'success'
  }

  private dataFeedChanged = (dataFeed: DataFeed) =>
    this.props.dataFeedChanged({
      ...dataFeed,
      dateEdited: new Date(),
      editedByNT4Name: 'you',
      validation:
        !dataFeed.enabled && !dataFeed.reasonNotEnabled && this.props.hasUnsavedChanges
          ? [
              {
                field: 'ReasonNotEnabled',
                message: 'You must detail the reason this data feed is not enabled'
              }
            ]
          : []
    })

  private handleEnabledChanged = () => {
    this.dataFeedChanged({
      ...this.props.dataFeed,
      enabled: !this.props.dataFeed.enabled
    })
  }

  private handleReasonChanged = (e: string) => {
    // don't leave enabled as null if the reason has been set
    this.dataFeedChanged({
      ...this.props.dataFeed,
      reasonNotEnabled: e,
      enabled: false
    })
  }
}
